// Local UI state only. Expiry and ownership are always enforced by the server.
const forms = new WeakMap();
export function bindClaimSessionForm(form, {start, account, pinName = "pin", enabled = true}) {
  if (!form || forms.has(form)) return;
  const id = form.elements.deviceId, pin = form.elements[pinName];
  const startButton = document.createElement("button");
  startButton.type = "button"; startButton.className = "button"; startButton.textContent = "Start registration";
  const note = document.createElement("p"); note.setAttribute("role", "status");
  note.textContent = "Enter the Pirdy ID and start registration. Then tap Add an Account on the Wi-Fi-connected Pirdy.";
  id.closest("label").after(startButton, note);
  const owner = account();
  const state = {session: null, owner, id: "", requestId: null, busy: false, deadline: 0};
  forms.set(form, state); pin.disabled = true;
  startButton.addEventListener("click", async () => {
    if (state.busy || !enabled || account() !== owner) return;
    if (!id.reportValidity()) return;
    const deviceId = id.value.trim().toUpperCase();
    if (deviceId !== state.id || state.session && performance.now() >= state.deadline) state.requestId = null;
    state.id = deviceId; state.requestId ??= crypto.randomUUID();
    state.busy = true; startButton.disabled = true; pin.disabled = true;
    try {
      const session = await start(deviceId, state.requestId);
      if (!form.isConnected || account() !== owner || id.value.trim().toUpperCase() !== deviceId) return;
      if (!session?.sessionId || !(session.validForSeconds > 0 && session.validForSeconds <= 900)) throw new Error("Invalid registration session.");
      state.session = session; state.deadline = performance.now() + session.validForSeconds * 1000;
      pin.disabled = false; pin.value = "";
      note.textContent = "Tap Add an Account on the Pirdy, then enter its displayed PIN. PIN changes every 5 minutes; registration ends after 15 minutes. After expiry choose Try again here and tap the device button again.";
      startButton.textContent = "Try again"; pin.focus();
    } catch {
      note.textContent = "Registration could not start. Check the ID and connection, or wait for an existing session to expire, then try again.";
    } finally {state.busy = false; startButton.disabled = false;}
  });
  id.addEventListener("input", () => {state.session = null; state.requestId = null; pin.value = ""; pin.disabled = true;});
}
export function claimSessionFor(form, account) {
  const state = forms.get(form);
  if (!state?.session || state.owner !== account || state.busy ||
      state.id !== form.elements.deviceId.value.trim().toUpperCase() || performance.now() >= state.deadline)
    throw new Error("Start registration or choose Try again, then tap Add an Account on the Pirdy.");
  return state.session.sessionId;
}
